import Bloc from './Bloc.js';
import Types from './Types.js';

export default class FilterAdjacentFromPlay extends Bloc {

	constructor (src, ctx) {

		super("filteradjfromplay", src, ctx);
		this.f = (src, ins) => [card => card.adjLeftFromPlay || card.adjRightFromPlay, card => card.adjLeftFromPlay, card => card.adjRightFromPlay];
		this.types = [];
	}
}